import React from "react"
import { MarcaCaldaiaSelector } from "../../marcheClima/components/modelliClimaSelector"
import { ModelliClimaSelector } from "./ModelliClimaSelector"
import { ModelloClimaDto } from "../../generated"
import { ModelliClimaStore } from "../ModelliClimaStore"
import { ModelloClimaToolbarButton } from "./ModelloClimaDialog"

interface Props {
    value: number | null,
    onChange: (type: ModelloClimaDto | null) => void
    error?: string;
}

export const SmartModelloClimaSelector = (props: Props) => {
    const modelloClima = ModelliClimaStore.use(props.value && props.value || null);
    const [marca, setMarca] = React.useState(modelloClima?.marca ?? null);
    const marcaClima = marca ?? modelloClima?.marca ?? "";

    const onChangeMarca = (m: string | null) => {
        setMarca(m);
        props.onChange(null);
    }

    return <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between">
            <div className="text-uppercase fw-bold">
                Selezione Apparecchio
            </div>
        </div>
        <div className="card-body pt-0 pb-0">
            <MarcaCaldaiaSelector
                onChange={onChangeMarca}
                value={marcaClima}
                label="Produttore"
                error={props.error}
            />
            {marcaClima && <ModelliClimaSelector
                marca={marcaClima}
                value={modelloClima?.id ?? null}
                onChange={props.onChange}
                label="Modello"
                error={props.error}
            />}
        </div>
        <div className="card-footer">
            <ModelloClimaToolbarButton
                id={modelloClima?.id}
                onSelect={props.onChange}
            />
        </div>
    </div>
}